/** Контекст лівого меню модуля за маршрутом і сторінки модуля, які меню показує в кожному контексті (прототип v4). Чисті функції. */
import type { IRecordTypeDefinition } from '@platform/core/types';
import type { IMenuLink } from './IMenuLink';
import { LAW_MODEL_PAGE } from './lawModelLink';
import type { MenuContextKind } from './MenuContextKind';
import { isStandardPage } from './modulePages';

/** Сторінки модуля на сторінці запису: аналітика й аналітичні подання — лише на сторінках модуля (прототип mnI для page==='module'). */
const RECORD_PAGES: readonly string[] = ['overview', 'advisory', 'pcal', 'help', LAW_MODEL_PAGE];

/** Сторінки модуля в налаштуваннях і «Моделі даних»: прототип лишає Огляд і Поради (mnHasOverview), довідку й аналітику — ні. */
const CONFIG_PAGES: readonly string[] = ['overview', 'advisory'];

/**
 * Контекст меню: сторінка налаштувань модуля `onSettings` чи розділ «Модель даних» (`design` = model) — `config`; інший розділ «Проєктування» —
 * `design`; сторінка запису (`recordId`) — `record`; інакше `module`.
 */
export function moduleMenuContextOf(design: string | undefined, onSettings: boolean, recordId: string | undefined): MenuContextKind {
  if (onSettings || design === 'model') return 'config';
  if (design) return 'design';
  return recordId ? 'record' : 'module';
}

/**
 * Подання, які меню головного типу перелічує поза групою «Views» (прототип fromMenu: пункт «Матриця ризиків» у групі «Ризики» стає сторінкою
 * модуля й поза списком; група «Views» прототипу в меню не потрапляє, тож «Зал засідань» звідти — ні).
 */
export function menuViewsOf(rt: IRecordTypeDefinition): string[] {
  return rt.menu.filter((g) => g.group.en !== 'Views').flatMap((g) => (g.items ?? []).flatMap((it) => (it.view ? [it.view] : [])));
}

/**
 * Сторінки модуля в меню за контекстом (прототип v4: mnHasOverview, mnHasHelp, mnI, mnHasPcal, mnHasLawModel): на сторінці запису — Огляд ·
 * Поради · Календар · Довідка · Візуальна модель закону; у налаштуваннях і «Моделі даних» — Огляд і Поради, а в модулях із власним меню
 * прототипу (`ownMenu`: завдання, база знань) — жодної; у розділах-списках «Проєктування» — чотири стандартні й аналітичні подання з меню
 * головного типу (`menuViews`, menuViewsOf; у модулях із власним меню — лише стандартні); на сторінках модуля — усі.
 */
export function pagesForContext(links: IMenuLink[], context: MenuContextKind, ownMenu: boolean, menuViews: readonly string[] = []): IMenuLink[] {
  switch (context) {
    case 'record': return links.filter((l) => RECORD_PAGES.includes(l.key));
    case 'config': return ownMenu ? [] : links.filter((l) => CONFIG_PAGES.includes(l.key));
    case 'design': return links.filter((l) => isStandardPage(l.key) || (!ownMenu && menuViews.includes(l.key)));
    default: return links;
  }
}
